var MCUtil = {};
var d3 = require('d3');

MCUtil.divTextFit = function(node, startFont) {
    var font = startFont ? startFont : 24;
    node.style["font-size"] = font + "px";
    while(node.scrollWidth > node.offsetWidth) {
        node.style["font-size"] = font + "px";
        font--;
    }
}

MCUtil.getFrequency = function(string, char) {
    var freq = {};
    for (var i=0; i<string.length;i++) {
        var character = string.charAt(i);
        if (freq[character]) {
           freq[character]++;
        } else {
           freq[character] = 1;
        }
    }

    return freq[char] !== null ? freq[char] : 0;
};

MCUtil.randomString = function(length) {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  
    for (var i = 0; i < length; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));
  
    return text;
}

MCUtil.toNum = function(str) {
    var neg = false;
    if(typeof str != "string"){
        return str;
    }
    str.indexOf('-') > -1 ? neg = true : neg = false;
    str = str.replace(/[^0-9.]/g, "");
    if(str.length == 0) {
        return 0;
    }
    str = parseFloat(str);
    return neg ? 0 - str : str;
}

MCUtil.formatPhoneNumber = function(phoneNumberString, raw) {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    var match = cleaned.match(/^(\d{3})(\d{3})(\d{4,})$/);
    if(raw && match) {
        return match[1]+match[2]+match[3].substring(0,4);
    }
    if (match) {
        console.log('last match - ', match[3].substring(0,4));
        return ['(', match[1], ') ', match[2], '-', match[3].substring(0,4)].join('');
    }
    return null;
}

//To convert an int or a float into a formatted number #,###,###.##, y is number of decimal places
MCUtil.format = function(x, y, noCommas) {
    var parts;
    if(y && parseInt(y) > 0 && x.toString().indexOf('.') < 0) {
        parts = (x.toString()+".0").split(".");
    } else {
        parts = x.toString().split(".");
    }
    if(!noCommas) {
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    if(parts[1]) {
        //console.log(parts[1]);
        parts[1] = parts[1].substring(0,(y?y:2));
        while(parts[1].length < (y?y:2)) {
            parts[1] += '0';
        }
    }
    return parts.join(".");
}

//from MDN on math.round()
MCUtil.precisionRound = function(number, precision) {
    var factor = Math.pow(10, precision);
    return Math.round(number * factor) / factor;
}

MCUtil.setDescendantProp = function(obj, desc, value) {
    var arr = desc.split('.');
    while (arr.length > 1) {
        var x = arr.shift();
        if(x == '""' || x == "") {
            continue;
        }
        obj = obj[x];
    }
    if(arr[0] == "") {
        //console.log('setting obj');
        obj = value;
        return true;
    }
    if(typeof obj[arr[0]] != typeof value) {
        //console.log('here');
    }
    if(obj[arr[0]] != value || typeof obj[arr[0]] == "object" || typeof obj[arr[0]] != typeof value) {
        //console.log(obj[arr[0]], value, "setDescendentProp");
        obj[arr[0]] = value;
        return true;
    } else {
        //console.log('set decendent prop returning false!!');
    }

    return false;
}

MCUtil.getDescendantProp = function(obj, desc) {
    if(desc === "") {
        return obj;
    }
    var arr = desc.split('.');
    while (arr.length) {
        var x = arr.shift();
        if(x == '""' || x == "") {
            continue;
        }
        obj = obj[x];
    }
    return obj;
}

MCUtil.clone = function() {
    var newObj = (this instanceof Array) ? [] : {};
    for (var i in this) {
        if (this[i] && typeof this[i] == "object") {
            newObj[i] = this[i].clone();
        }
        else
        {
            newObj[i] = this[i];
        }
    }
    return newObj;
};

Object.defineProperty( Object.prototype, "clone", {value: MCUtil.clone, enumerable: false, writable: true});

MCUtil.shallowClone = function() { 
    var newObj = (this instanceof Array) ? [] : {};
    for (var i in this) {
        newObj[i] = this[i];
    }
    return newObj;
}
Object.defineProperty( Object.prototype, "shallowClone", {value: MCUtil.shallowClone, enumerable: false});

if (typeof Object.assign != 'function') {
    // Must be writable: true, enumerable: false, configurable: true
    Object.defineProperty(Object, "assign", {
      value: function assign(target, varArgs) { // .length of function is 2
        'use strict';
        if (target == null) { // TypeError if undefined or null
          throw new TypeError('Cannot convert undefined or null to object');
        }
  
        var to = Object(target);
  
        for (var index = 1; index < arguments.length; index++) {
          var nextSource = arguments[index];
  
          if (nextSource != null) { // Skip over if undefined or null
            for (var nextKey in nextSource) {
              // Avoid bugs when hasOwnProperty is shadowed
              if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                to[nextKey] = nextSource[nextKey];
              }
            }
          }
        }
        return to;
      },
      writable: true,
      configurable: true
    });
  }

//thanks to Mike Bostock - https://bl.ocks.org/mbostock/7555321
MCUtil.svgTextWrap = function(text, width, lHeight, ln) {
    text.each(function() {
        var text = d3.select(this),
            words = text.text().split(/\s+/).reverse(),
            word,
            line = [],
            lineNumber = 0,
            lineHeight = lHeight || 1.1, // ems
            y = text.attr("y");

        //console.log(parseFloat(text.attr("fdx")));
        var dy = parseFloat(text.attr("dy")) || 0;
        var dx = parseFloat(text.attr("dx")) || 0;
        var tspan = text.text(null).append("tspan").attr("x", 0).attr("y", y).attr("dy", dy + "em").attr("dx", dx);

        while (word = words.pop()) {
            //console.log(word);
        line.push(word);
        tspan.text(line.join(" "));
        if (tspan.node().getComputedTextLength() > width) {
            lineNumber++;
            line.pop();
            tspan.text(line.join(" "));
            line = [word];
            tspan = text.append("tspan").attr("x", 0).attr("y", y).attr("dx", dx).attr("dy", lineNumber * lineHeight + dy + "em").text(word);
            if(ln) {
                ln.val = lineNumber;
            }
        }
        }
    });
}

//exactly as the name implies
MCUtil._arrayBufferToBase64 = function( buffer ) {
    var binary = '';
    var bytes = new Uint8Array( buffer );

    // var decoder = new TextDecoder("utf8"); 
    // return decoder.decode(buffer);
    console.log( typeof buffer );

    var len = bytes.byteLength;
    for (var i = 0; i < len; i++) {
        binary += String.fromCharCode( bytes[ i ] );
    }
    return window.btoa( binary );
}

//from Stack Overflow
MCUtil.forceHalt = function(milliseconds) {
    var start = new Date().getTime();
    for (var i = 0; i < 1e7; i++) {
        if ((new Date().getTime() - start) > milliseconds){
            break;
        }
    }
}

MCUtil.loadJSON = function(url, callback) {   
    var xobj = new XMLHttpRequest();
    xobj.overrideMimeType("application/json");
    xobj.open('GET', url, true); // Replace 'my_data' with the path to your file
    xobj.onreadystatechange = function () { // Required use of an anonymous callback as .open will NOT return a value but simply returns undefined in asynchronous mode
          if (xobj.readyState == 4 && xobj.status == "200") {
            callback(xobj.responseText);
          }
    };
    xobj.send(null);  
}

MCUtil.sendXHR = function(url, data, method, contentType, successCallback, failCallback, tag, headers) {
    var xhr = new XMLHttpRequest();
    var xhrPromise = new Promise(function(resolve, reject) {
        // if(!data) {
        //     data = {};
        // }
        // if(method == "GET") {
        //     console.log(url);
        // }
        xhr.open(method, url, true);
        if(data) {
            xhr.setRequestHeader("Content-Type", contentType ? contentType : "application/json");
        }

        if(headers) {
            for(var i = 0; i < headers.length; i++) {
                xhr.setRequestHeader(headers[i].header, headers[i].value);
            }
        }
    
        xhr.onreadystatechange = function() {
            if(xhr.readyState == XMLHttpRequest.DONE && xhr.status == 200) {
                // if(tag && xhr.response && !window.isProd) {
                if(tag && xhr.response) {
                    console.log(tag + ' success:', JSON.parse(xhr.response));
                }
                if(successCallback && typeof successCallback == 'function') {
                    successCallback(xhr);                    
                }
                resolve(xhr);
            }
        }
        
        if(data) {
            xhr.send(JSON.stringify(data));
        } else {
            xhr.send();
        }
        xhr.onerror = function() {
            if(tag && !window.isProd) {
                console.log(tag + ' fail');
            } else if(!window.isProd) {
                console.log(xhr);
            }
            if(failCallback && typeof failCallback == 'function') {
                failCallback(xhr);                
            }
            reject(xhr);
        }
    });
    xhrPromise.xhrRequest = xhr;
    return xhrPromise;
}

//COOKIES - CANT TEST ON LOCAL FILES WITHOUT LOCALHOST
//to set cookies
MCUtil.setCookie = function(cname, cvalue, ctime, isSessionCookie) {
    var cokTime = 5000;
    if(ctime) {
        cokTime = ctime;
    }
    var d = new Date();
    d.setTime(d.getTime() + (cokTime));
    var expires = "expires="+ d.toUTCString();
    if(isSessionCookie) {
        document.cookie = cname + "=" + cvalue + ";";
        return;    
    }
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

MCUtil.deleteCookie = function(cName) {
    document.cookie = cName + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
}

//to get cookie
MCUtil.getCookie = function(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

MCUtil.createPresentationBarChart = function(fields, mappings, containerID, ops, entries, label, thisChart) {
    var tooltipDiv = d3.select(document.getElementsByClassName("presi-chart-tooltip")[0]);
    var redrawChart = false;

    if(thisChart) {
        redrawChart = thisChart.entries.length != entries.length;
    }

    var chart = thisChart || {};
    chart.fields = fields;
    chart.mappings = mappings;
    chart.containerID = containerID;
    chart.ops = ops;
    chart.entries = entries;
    chart.label = label;

    if(!document.getElementById(chart.containerID)) {
        return;
    }

    chart.chartParent = document.getElementById(chart.containerID).parentNode;
    //console.log('initial chart.stacked', chart.stacked);
    chart.pastStacked = (chart.stacked != undefined) ? chart.stacked : null;
    chart.stacked = chart.chartParent.className.indexOf('stacked') > -1;
    chart.stackedChanged = (chart.pastStacked != null) ? (chart.pastStacked != chart.stacked) : true;
    redrawChart = chart.stackedChanged || redrawChart;
    

    //console.log("chart.stackedChanged, chart.stacked, chart.pastStacked", chart.stackedChanged, chart.stacked, chart.pastStacked);

    var transitionDuration = 350;

    //used to shape the data, used to calculate total for stacked bar charts
    chart.shapeData = function() {
        var dataOA = [];
        chart.noDataOA = true;
        for(var i = 0; i < chart.entries.length; i++) {
            var dataPoint = new Object();
            var t = 0;
            dataPoint.Name = chart.entries[i].Name;
            dataPoint.Ind = i;
            for(var j = 0; j < chart.mappings.length; j++) {
                dataPoint[chart.mappings[j]] = MCUtil.toNum(chart.entries[i][chart.mappings[j]]);
                t += dataPoint[chart.mappings[j]];
                if(chart.noDataOA && dataPoint[chart.mappings[j]] != 0) {
                    chart.noDataOA = false;
                }
            }
            dataPoint.total = t;
            dataOA.push(dataPoint);
        }
        chart.data = dataOA;
    }

    //to calculate bot margin based off of fields in case we need a legend for a stacked chart
    chart.calcBotMargin = function(divisor) {
        var rows = Math.ceil(chart.fields.length / divisor);
        return (rows + 1) * 35;
    }

    //setup the chart's axis and color scaling and to attach the necessary containers
    //setup the chart's constant parameters and other chart meta data
    chart.setupChart = function() {
        chart.svg = d3.select("#"+chart.containerID).attr("width", chart.chartParent.offsetWidth).attr("height", chart.chartParent.offsetHeight);
        //isSimple and isLessSimple are for smaller window sizes
        chart.isSimple = false;
        chart.isMobile = false;
        var cW = parseInt(chart.svg.attr("width"));   //window.innerWidth was used before
        if(cW < 630) {
            chart.isSimple = true;
            chart.margin = {top: 48, right:  32, bottom: chart.stacked ? chart.calcBotMargin(2) : 48, left: 40};
            chart.isMobile = true;
        } else {
            chart.isSimple = false;
            chart.margin = {top: 56, right: 48, bottom: chart.stacked ? chart.calcBotMargin(2) : 48, left: 56};
        }

        chart.width = +chart.svg.attr("width") - chart.margin.left - chart.margin.right;
        chart.height = +chart.svg.attr("height") - chart.margin.top - chart.margin.bottom;
        chart.container = chart.svg.append("g").attr("transform", "translate(" + chart.margin.left + "," + chart.margin.top + ")");
        chart.x = d3.scaleBand().rangeRound([0, chart.width]).paddingInner(0.05).align(0.1);
        chart.y = d3.scaleLinear().rangeRound([chart.height, 0]);
        chart.z = d3.scaleOrdinal().range(chart.ops.columnColors); //scales (maps) colors based on key (index i think)

        chart.shapeData();
        chart.yMin = d3.min(chart.data, function(d) {return d.total;});
        chart.yMax = d3.max(chart.data, function(d) {return d.total;});
        if(chart.yMax == chart.yMin) {
            chart.yMax += 100;
        }
        chart.x.domain(chart.data.map(function(d, i) {return i;}));
        chart.y.domain([(chart.yMin < 0 ? chart.yMin : 0), chart.yMax]).nice(4);
        chart.z.domain(chart.mappings);

        chart.xAxis = chart.container.append("g");
        chart.yAxis = chart.container.append("g");
        chart.barLayers = chart.container.append("g");
        chart.rectLayer = chart.barLayers.selectAll("g").data(d3.stack().keys(chart.mappings)(chart.data)).enter().append("g");
        chart.rects = chart.rectLayer.selectAll("rect").data(function(d) {return d;}).enter().append("rect");
        chart.rectText = chart.rectLayer.selectAll("text").data(function(d, i) { return i == chart.mappings.length - 1 ? d : []}).enter().append("text");
        chart.ndOAtext = chart.container.append("g").append("text");
        chart.drawn = false;
    }

    chart.drawChart = function() {
        //X-AXIS --- for a more comprehensive explanation look at yaxis implementation
        //the returned object actually represents the text inside the axis
        chart.xAxis
            .attr("class", "axis x") //define attributes like this, get them with just a key of type string, so like .attr('attribute')
            .attr("transform", "translate(0,"+(chart.height+5)+")")
            .style("font-size", "12px")
            .attr("font-family", "MC_font")
            .call(d3.axisBottom(chart.x).tickSize(0).tickFormat(function(d, i) { return chart.data[i].Name.toUpperCase(); }))
            .selectAll("text").attr("fill","#333333")
            .call(MCUtil.svgTextWrap, chart.x.bandwidth());
            //.attr("transform", chart.isSimple ? (chart.entries.length > 3 ? "translate(0,-15) rotate(20)" : "translate(0,-15)") : (chart.isLessSimple ? (chart.entries.length > 3 ? "translate(0,15) rotate(10)" : "translate(0,15)") :  "translate(0,5)"));

        //Y-AXIS
        chart.yAxis
            .attr("class", "axis y")
            .style("font-size",chart.isMobile ? "10px" : "12px");

                chart.yTicks = chart.yAxis.call(d3.axisLeft(chart.y).ticks(4).tickSize(chart.width).tickFormat(function(d) {return d3.format("$.2s")(d);})) //the first line of this expression returns the ticks object which I store
                .attr("transform", chart.isSimple ? "translate("+chart.width+")" : "translate("+chart.width+")");                             //and manipulate the attributes of here in the second line
            
                chart.yTicks.selectAll("text") //the ticks have text which I select here and manipulate below, ALSO SELECTS YLABEL IF DRAWN!!!!!
                .attr("transform", "translate(0,0)")
                .attr("font-family", "MC_font")
                .attr("fill",(chart.isSimple && !chart.isMobile) ? ("#ffffff") : "#333333");

                if(chart.drawn == true) { 
                    chart.yLabel.attr("transform", "translate("+((chart.width + chart.margin.right - 8) * -1)+","+(-24)+")"); //FIXES YLABEL MOVEMENT FROM ABOVE IF DRAWN
                };

                chart.yTicks.selectAll("line") //the ticks have lines which I manipulate here
                    .attr("opacity", "0.7")
                    //.transition().duration(transitionDuration)
                    .attr("stroke", function(d) { return (d != 0 ? "lightgrey" : "#333333"); });



        //RECTANGLES
        chart.barLayers //determine if it needs an ID based off of provided highlightMapping, so if it could be highlighted
            .attr("id", function (d) {return (chart.ops.highlightMapping) ? chart.ops.highlightMapping + "-chart" : false; })

        chart.rectLayer //rectLayers and barLayers were defined in setupChart
            .attr("fill", function(d, i) {
                for(var j = 0; j < d.length; j++) {
                    d[j].field = typeof chart.fields == 'object' ? chart.fields[i] : chart.fields; //I set each data sets field right here for some reason
                }
                return chart.z(d.key); //this function is meant to return the color value from our oridnal scaling
            })
            .attr("id", function(d) { return d.key; });

        chart.calcY = function(d) { return (chart.y(d[0]) - chart.y(d[1]) > 0 ? chart.y(d[1]) : chart.y(d[0])); }; // this sets the anchor y position of the bar based off of wheather it was positive or negative
        chart.calcHeight = function(d) { return Math.abs(chart.y(d[0]) - chart.y(d[1])) > 0 ? Math.abs(chart.y(d[0]) - chart.y(d[1])) : 1 }; //sets height to 1 if its zero

        //sets the bar width with d3's scaleBand's bandwidth function
        var barSpacing = chart.isMobile ? 10 : 40;
        chart.barWidth = (chart.x.bandwidth() - barSpacing) > 100 ? 100 : ((chart.x.bandwidth() - barSpacing) > 0 ? chart.x.bandwidth() - barSpacing : 5);

        chart.rects //sets event listeners for the chart's tooltip
            .on("mouseover", function(d, i) {
                //console.log(d, d.data, d.data.Name);
                tooltipDiv.transition().duration(transitionDuration).style("opacity", 1).style("z-index",50);
                tooltipDiv.html("<span style='font-size: 16px; font-weight: 600; font-family: MC_font;'>"+d.data.Name.toUpperCase() + "</span><br>"
                 + d.field + ": <span style='font-weight: 600; font-family: MC_font;'>$" + MCUtil.format(d[1] - d[0]) + "</span>")
                .style("left", (i < Math.floor(chart.entries.length/2) ? d3.event.pageX + 5 : d3.event.pageX - MCUtil.toNum(tooltipDiv.style("width")) - 20) + "px")
                .style("top", (d3.event.pageY - 100) + "px");
                d.tipLeft = (d3.event.pageX);
                d.tipTop = (d3.event.pageY);
            })
            .on("mousemove", function(d, i) {
                tooltipDiv.style("transform","translate("+(d3.event.pageX - d.tipLeft)+"px,"+(d3.event.pageY - d.tipTop)+"px)");
            })
            .on("mouseout", function(d) {
                tooltipDiv.transition().duration(200).style("opacity", 0).style("z-index",0);
                delete d.tipLeft;
                delete d.tipTop;
            })
            // .transition().duration(transitionDuration)
            .attr("x", function (d, i) {return chart.x(i) + 20; })
            .attr("transform", "translate("+((chart.x.bandwidth() - 40 - chart.barWidth)/2)+",0)");
            if(chart.drawn !== true) {
                chart.rects.attr("y", function (d) {return chart.y(0); })
            }
            chart.rects.transition().duration(transitionDuration)
            .attr("y", function (d) {return chart.calcY(d); })
            .attr("height", function (d) {return chart.calcHeight(d); })
            .attr("width", (chart.barWidth))
            .attr("opacity", chart.ops.ohfPrint ? "1" : "0.7")
            .attr("fill", function(d, i) {return ((chart.y(d[0]) - chart.y(d[1]) < 0) ? "#ff5656" : ""); })
            .attr("cell-highlight-type", "chart") //sets highlight type needed for highlighting
            .attr("entry-index", function(d, i) {return i; })
            .attr("entry-mapping", function(d, i) {return chart.ops.highlightMapping; });
            // .attr("transform", "translate("+((chart.x.bandwidth() - 40 - chart.barWidth)/2)+",0)");

        chart.rectText
            .transition().duration(transitionDuration)
            .text(function(d) { return '$' + MCUtil.format(d.data.total); });

        chart.rectText.attr("text-anchor", "middle")
            //.attr("class", "bar-text")
            .attr("fill", function(d, i) { return ((chart.y(d[0]) - chart.y(d[1])) < 0) ? "#ff5656" : (mappings.length == 1 ? "" : "#333333"); })
            .attr("font-family", "MC_font")
            .attr("transform", function(d, i) {
                    return "translate("+(chart.x(i) + chart.x.bandwidth()/2)+", "+(chart.calcY(d) - 5)+")";
            })
            .each(function(d) {
                window.setTimeout(function(){
                    d.width = this.getBBox().width;
                    var nextFont = 14;
                    while(this.getBBox().width > chart.barWidth) {
                        var size = nextFont + "px";
                        d3.select(this).attr('font-size', size);
                        nextFont--;
                        if(nextFont < 0) {
                            break;
                        }
                    }
                }.bind(this), 1000);
            });

        chart.drawn = true;
        //end rectangels
    }

    chart.addNoDataText = function() {
        if(chart.noDataOA) {
            var ndoat = chart.ndOAtext.text("Your payments are equal").attr("opacity", "1")
            .attr("font-family", "MC_font").attr("font-size", "50px").attr("text-anchor", "middle").attr("dy","0em").attr("y","0")
            .attr("transform", "translate("+(chart.width/2)+","+(chart.height/2)+")");

            var ln = {'val': 0};
            chart.ndOAtext.call(MCUtil.svgTextWrap, Math.floor(chart.width), 1.1, ln);

            ndoat.attr("transform", "translate("+(chart.width/2)+","+((chart.height/2) - (ln.val * 66/2))+")");
            //return;
        } else if(chart.ndOAtext) {
            chart.ndOAtext.text("").attr("opacity", "0");
        }
    }

    chart.finishSetup = function() {
        // if(chart.noDataOA) {
        //     var ndoat = chart.ndOAtext.text("Your payments are equal").attr("opacity", "1")
        //     .attr("font-family", "MC_font").attr("font-size", "50px").attr("text-anchor", "middle").attr("dy","0em").attr("y","0")
        //     .attr("transform", "translate("+(chart.width/2)+","+(chart.height/2)+")");

        //     var ln = {'val': 0};
        //     chart.ndOAtext.call(MCUtil.svgTextWrap, Math.floor(chart.width), 1.1, ln);

        //     ndoat.attr("transform", "translate("+(chart.width/2)+","+((chart.height/2) - (ln.val * 66/2))+")");
        //     //return;
        // }
        chart.addNoDataText();
        //LEGEND
        var fs = "15px";
        //use spacing and divisor to position the legend text and rectangles and the container as well
        var divisor = chart.isSimple ? 2 : chart.fields.length;
        var spacing = (chart.width) /(divisor);
        if(chart.fields.length > 1 && typeof chart.fields == 'object') {
            //console.log(typeof chart.fields);
            chart.legend = chart.container.append("g").attr("id","legend-"+chart.containerID)
                .attr("font-family", "MC_font").attr("font-size", fs).attr("text-anchor", "end")
                .attr("transform", "translate(0,0)")
                // .attr("transform", chart.isSimple ? "translate(20,0)" : (chart.isLessSimple ? "translate(0,0)" : "translate("+(spacing/(divisor*2))+",0)"))
                .attr("transform", "translate("+(spacing/(divisor))+","+(-1 * chart.calcBotMargin(2) + 45)+")")
                .selectAll("g")
                .data(chart.fields.slice()).enter().append("g");

            chart.legend.append("rect")
                .attr("width", 19).attr("height", 19).attr("fill", chart.z).attr("opacity", chart.ops.ohfPrint ? "1" : "0.7")
                .attr("transform", function(d, i) {
                    var row = Math.floor(i/2);
                    var col = i%2; //0 or 1
                    return "translate("+(spacing*(col))+", "+(chart.height + 60 + (25 * (row)))+") rotate(0)";
                });

            chart.legend.append("text")
                .attr("dy", "0.867em").text( function (d) {return d; })
                .attr("transform", function(d, i) {
                    var row = Math.floor(i/2);
                    var col = i%2; //0 or 1
                    return "translate("+(spacing*(col) - 10)+", "+(chart.height + 60 + (25 * (row)))+") rotate(0)";
                }).call(MCUtil.svgTextWrap, Math.floor(spacing * 0.7), 0.1);

            //console.log('chart isSimple - ', chart.isSimple);
        }

        chart.yLabel = chart.yTicks.append("text")
            .attr("id", chart.containerID + "-label")
            .attr("font-family", "MC_font")
            .attr("transform", "translate("+((chart.width + chart.margin.right - 8) * -1)+","+(-24)+")")
            .attr("fill", "#333333")
            .attr("font-size", chart.isSimple ? ("16px") : "20px")
            .attr("text-anchor", "start")
            .text(chart.label);
    }

    //(TASK-MAJOR) consolidate updateChart and redraw into one function that smoothly transitions the chart to its next state regardless of whether
    //             it is updated or redrawn

    //to update the chart without redrawing
    chart.updateChart = function() {
        chart.shapeData();
        chart.yMin = d3.min(chart.data, function(d) { return d.total; });
        chart.yMax = d3.max(chart.data, function(d) { return d.total; });
        if(chart.yMax == chart.yMin) {
            chart.yMax += 100;
        }
        chart.x.domain(chart.data.map(function(d, i) { return i; }));
        chart.y.domain([(chart.yMin < 0 ? chart.yMin : 0), chart.yMax]).nice(4);
        chart.z = d3.scaleOrdinal().range(chart.ops.columnColors); //scales (maps) colors based on key (index i think)
        chart.z.domain(chart.mappings);

        chart.rectLayer = chart.barLayers.selectAll("g").data(d3.stack().keys(chart.mappings)(chart.data));
        chart.rects = chart.rectLayer.selectAll("rect").data( function(d) {return d; });
        chart.rectText = chart.rectLayer.selectAll("text").data( function(d, i) { return i == chart.mappings.length - 1 ? d : []; });
        chart.yLabel.text(chart.label);
        chart.drawChart();
        chart.addNoDataText();
    }

    chart.redraw = function() {
        document.getElementById(chart.containerID).innerHTML = "";
        chart.setupChart();
        chart.drawChart();
        chart.finishSetup();
    }

    //utility function not really used, but here for facilitating future print versions
    chart.changeTransitionDuration = function(x) {
        chart.yTicks.selectAll("line").transition().duration(x);
        chart.rectText.transition().duration(x);
        chart.rects.transition().duration(x);
    }

    chart.highlightBar = function(ind, col) {
        // console.log('in highlight bar - ', col)
        var x = chart.rectLayer.selectAll("rect")._groups[0][ind];
        d3.select(x).style("fill",col ? col : "gold");

        var y = chart.rectText._groups[0][ind];
        d3.select(y).style("fill",col ? col : "gold");

        console.log(chart.rectText);
        // console.log(x);
    }

    if(thisChart) {
        if(redrawChart) {
            console.log('in redraw');
            chart.redraw();
        } else {
            chart.updateChart();
        }
    } else {
        chart.setupChart();
        chart.drawChart();
        chart.finishSetup();
    }

    return chart;
}

console.log("MCUtil is this run?");
window.divTextFit = MCUtil.divTextFit;

export default MCUtil;


// WEBPACK FOOTER //
// ./src/MCUtil.js